// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "utf-8";

.traffic_main_container__Xukm1 {
  max-width: 1920px;
  width: 100%;
  background-color: #fff;
  margin: 10px auto 0;
}

.traffic_page_container__JEyof {
  padding-left: 24px;
}

.traffic_content_box__VLQGq {
  padding-top: 72.65px;
  background-color: #f2f2f2;
  position: fixed;
  max-width: 1920px;
  width: 100%;
}

.traffic_scroll_container__JnIQC {
  overflow-y: auto;
  min-height: calc((var(--vh, 1vh) * 100) - 110px);
}

.traffic_scroll_h_container__rCBtT {
  overflow-y: auto;
  /* height: calc((var(--vh, 1vh) * 100) - 113px); */
  height: calc((var(--vh, 1vh) * 100) - 113px);
}

.traffic_detail_scroll__RBaA5 {
  height: calc((var(--vh, 1vh) * 100) - 110px);
  overflow-y: auto;
}

.traffic_scroll_container__JnIQC.traffic_detail_scroll__RBaA5 {
  height: calc((var(--vh, 1vh) * 100) - 110px);
}

.traffic_top_bar__XkAeX {
  width: 99%;
  position: absolute;
  z-index: 99;
  background-color: #fff;
  padding-top: 13px;
  top: 0;
  padding-left: 24px;
}

.traffic_content_title__6Yla\\+ {
  position: sticky;
  top: 48px;
  font-size: 22.5px;
  font-weight: 800;
  background-color: #fff;
  z-index: 11;
  padding-top: 28px;
}

.traffic_content_sub_title__0IRWg {
  position: sticky;
  font-weight: 800;
  font-size: 19px;
  top: 97.5px;
  background-color: #fff;
  z-index: 1;
  padding-top: 15px;
  padding-bottom: 10px;
}

.traffic_content_inner_title__ExkAw {
  position: sticky;
  top: 140px;
  font-weight: 700;
  padding-top: 2px;
  padding-bottom: 10px;
  background-color: #fff;
}

.traffic_content_wrapper__vc1u7 {
  padding-top: 34px;
  --bs-gutter-x: 0 !important;
  margin-top: 0 !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.traffic_item_sort__U62Vk {
  --bs-gutter-x: 0 !important;
}

.traffic_item_sort__U62Vk > * {
  padding-right: 23px;
  padding-left: 0px !important;
}

.traffic_content_text__7M-Tz {
  white-space: pre-wrap;
}

.traffic_list_img__\\+GO4n {
  width: 100%;
  overflow: hidden;
  aspect-ratio: 5 / 3;
  background-color: rgb(164, 164, 164);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.traffic_list_img__\\+GO4n img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.traffic_toTop__RdBfn {
  cursor: pointer;
  margin-left: auto;
  padding-right: 24px;
}

.traffic_icon_wrapper__94qQD {
  height: 28px;
  width: 28px;
}

.traffic_icon_wrapper__94qQD img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
}

.traffic_item_wrapper__kvCcX {
  background-color: #f2f2f2;
  cursor: pointer;
  transition: 0.4s;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.traffic_item_wrapper__kvCcX.traffic_active__NMLlu {
  background-color: #fff2e9;
}

.traffic_item_wrapper__kvCcX .traffic_list_img__\\+GO4n img {
  transition: all 0.5s ease-in-out;
}

.traffic_item_wrapper__kvCcX.traffic_active__NMLlu .traffic_list_img__\\+GO4n img {
  width: 110%;
  height: 110%;
}

.traffic_detail_width__PgRt6 {
  width: calc(100% - 153px);
}

.traffic_detail_container__Ef4Hd {
  margin-left: 0 !important;
  gap: 7px;
  width: calc(100% - 183px);
  min-height: calc((var(--vh, 1vh) * 100) - 98px);
  flex-wrap: nowrap;
}

.traffic_detail_text_container__Ly-Nd {
  background-color: #fff;
  padding: 61px 17px 0 17px;
  overflow: visible;
  min-width: 422.5px;
}

.traffic_icon18px__1FKjy {
  width: 18px;
  height: 18px;
}

.traffic_main_img_wrapper__I-IvW {
  width: 100%;
  height: 27.5vw;
  background-color: #f2f2f2;
}

.traffic_main_img_wrapper__I-IvW img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.traffic_media_wrapper__\\+T9ZR {
  padding: 10px 6.5px 9px 8.5px;
  flex-grow: 1;
}

.traffic_media_name__2Lshk {
  font-size: 17.5px;
  font-weight: 800;
  /* padding-bottom: 8px; */
  line-height: 1;
}

.traffic_media_type__ce3AZ {
  padding-bottom: 13px;
  font-size: 10px;
  line-height: 1;
}

.traffic_media_option__MQFcE {
  padding-bottom: 5px;
  font-size: 10px;
  display: flex;
  gap: 7px;
  line-height: 1;
}

.traffic_detail_mobile_content__XvVf8 {
  padding-left: 21px !important;
  padding-right: 21px !important;
}

.traffic_option_price__Wvk9U {
  font-size: 15px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: auto;
  line-height: 1;
}

.traffic_slick_dots__pyCIG {
  position: static !important;
  text-align: start !important;
  /* width: auto !important; */
  white-space: nowrap;
  overflow-x: auto;
}

.traffic_slick_dots__pyCIG::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari, Opera*/
}

.traffic_slick_dots__pyCIG li {
  margin: 0 4px 0 0 !important;
  width: 8vw !important;
  height: 4vw !important;
}

.traffic_buttonGroup__GCKN1 {
  height: 40px;
  width: 40px;
}

.traffic_buttonGroup__GCKN1 img {
  height: 100%;
}

.traffic_row__wmPY- {
  --bs-gutter-x: 0.3rem;
}

.traffic_px_30px__yDTaS {
  padding-left: 30px;
  padding-right: 30px;
}

/* .cart_wrapper,
.guide_wrapper {
  width: 320px;
  left: 50%;
  transform: translateX(-50%);
} */

/* .guide_wrapper {
  width: 500px;
} */

.traffic_cart_border__xGnti {
  border: 1px solid #971b4d;
  background-color: #ffffffb4;
  padding: 15px 11px 12px 12px;
}

.traffic_slider_wrapper__tnAs- {
  width: 100%;
  padding: 0 12px;
}

.traffic_swiper_thumbnail_wrapper__ckH\\+R {
  margin-top: 5.5px;
}

.traffic_swiper_thumbnail_wrapper__ckH\\+R img {
  width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: cover;
}

/* .swiper_thumbnail_wrapper .swiper_thumbnail {
  opacity: 0.4;
} */

.traffic_slider_container__WgUes {
  aspect-ratio: 16 / 9;
  overflow: hidden;
}

.traffic_slider_container__WgUes iframe,
.traffic_slider_container__WgUes img {
  min-height: 100%;
  min-width: 100%;
}

.traffic_slider_active_div__4HCz9 {
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  background-color: #f0f0f0;
  overflow: hidden;
}

.traffic_slider_media__VxWyb {
  width: 100% !important;
  height: 100% !important;
}

.traffic_slider_thumbnail__bKP8R {
  /* width: 100% !important; */
  aspect-ratio: 16 / 9 !important;
}

.traffic_slider_shadow__txwsZ {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  box-shadow: 0 0 0 3px #971b4d inset;
}

.traffic_bd_bottom_dashed__vmNjL {
  /* border-bottom: 1px dashed #e0e0e0; */
  padding: 13px 0;
}

.traffic_detail_info__GbwWT {
  padding-top: 39px;
  padding-left: 10px;
  padding-right: 10px;
}

.traffic_detail_info__GbwWT img {
  width: 100%;
}

.traffic_detail_option_container__vxVcF {
  height: calc((var(--vh, 1vh) * 100) - 98px);
  overflow: hidden;
  min-width: 422.5px;
  max-width: 422.5px;
  background-color: #fff;
  padding: 82.5px 23.5px 0 23.5px;
}

.traffic_option_select__ys6cq {
  width: 100%;
  background-color: #f2f2f2;
  height: 29px;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  /* color: hsl(0, 0%, 50%); */
  color: #000;
  cursor: pointer;
}

.traffic_media_name_width__7\\+0pU {
  width: 100%;
  max-width: 325px;
  padding: 0 16px;
}

.traffic_back_button__eC-cN {
  cursor: pointer;
  position: absolute;
  left: 23.5px;
}

.traffic_linkText__Y5qZG {
  text-decoration: underline;
}

.traffic_custom_paging__6XMxu .traffic_slick-slide__2Dojp {
  margin-right: 4px;
}

.traffic_custom_slider_a__-QMLq {
  position: relative;
  color: #000;
  font-weight: 700;
  cursor: pointer;
}

.traffic_custom_slider_a__-QMLq:focus-visible {
  outline: none;
}

.traffic_slick-slider__rX648 .traffic_slick-list__yKqoF {
  width: 100%;
}

.traffic_icon_size__sTDos {
  width: 36px;
  height: 36px;
  margin-right: 7.5px;
}

.traffic_custom_datepicker__msrTe {
  background-color: #f2f2f2;
  border: 0;
  text-align: center;
  padding: 0 2px;
  padding-right: 30px;
  width: 140px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
}

.traffic_option_ea__5BYDi {
  width: 88px;
  margin-left: 8.5px;
}

.traffic_custom_datepicker__msrTe:focus {
  border: 0;
}

/* .custom_datepicker::after {
  content: '';
  display: block;
  width: 16px;
  height: 16px;
  background: url('../../public/image/icon/detail_select.svg') no-repeat;
  background-size: contain;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
} */
.traffic_datepicker_arrow__lcZNS {
  top: 50%;
  transform: translateY(-50%);
  right: 5px;
  cursor: pointer;
  pointer-events: none;
}

.traffic_selectClose__wZKnR {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}

.traffic_fs_9px__EmysD {
  font-size: 9px;
}

.traffic_fs_10px__Ndm2y {
  font-size: 10px;
}

.traffic_fs_11px__yOJI8 {
  font-size: 11px;
}

.traffic_fs_12px__gVawU {
  font-size: 12px;
}

.traffic_fs_13px__2Fb4g {
  font-size: 13px;
}

.traffic_fs_14px__jQrDy {
  font-size: 14px;
}

.traffic_fs_17px__rd05G {
  font-size: 17px;
}

.traffic_fs_18px__BUr7z {
  font-size: 18px;
}

.traffic_fs_20px__iiR0R {
  font-size: 20px;
}

.traffic_fs_27px__\\+Dj9I {
  font-size: 27.5px;
}

.traffic_pfs_9px__0ZP9\\+ {
  font-size: 9.5px;
}

.traffic_pt_8px__YIICa {
  padding-top: 8px;
}

.traffic_pt_10px__jpJDh {
  padding-top: 10px;
}

.traffic_pt_13px__Yh63E {
  padding-top: 13px;
}

.traffic_pt_33px__e-J-s {
  padding-top: 33px;
}

.traffic_ppt_4px__1bDpT {
  padding-top: 4.5px;
}

.traffic_ppt_45px__bL67J {
  padding-top: 45.5px;
}

.traffic_py_20px__eoidu {
  padding-top: 20px;
  padding-bottom: 20px;
}

.traffic_ps_20px__QnP7r {
  padding-left: 18px;
}

.traffic_w_97px__4i-LP {
  width: 97px;
}

.traffic_customSelect__pqngE {
  width: 100%;
  border: 1px solid #961d4c;
  position: absolute;
  background-color: rgb(255, 255, 255);
  margin-top: 0.25rem;
  z-index: 9999;
}

.traffic_customOption__KLObe {
  font-size: 11px;
  text-align: center;
  cursor: pointer;
  line-height: 34px;
  font-weight: 700;
  padding-top: 0.1rem;
  padding-bottom: 0.1rem;
}

.traffic_customOption__KLObe:hover {
  background-color: #f2f2f2;
}

.traffic_tag_whole_group__pHswx {
  display: flex;
  align-items: center;
  gap: 7.5px;
  padding-right: 21px;
}

.traffic_tag_group__rNXn4 {
  flex-grow: 1;
  width: 100%;
  margin: 0 !important;
  align-items: center;
  justify-content: space-around;
  flex-wrap: nowrap;
  gap: 5.5px;
}

.traffic_tag_group__rNXn4.traffic_bd_bottom_dashed__vmNjL {
  padding-bottom: 7.5px;
}

.traffic_tag_color__Tiq3O {
  padding-top: 8px;
  padding-bottom: 7px;
  text-align: center;
  border-radius: 5px;
  font-size: 10px;
}

.traffic_tag_div__iCWz6 > div {
  flex: 1 1;
}

.traffic_item_grid__D\\+-l2 {
  padding-bottom: 24px;
}

.traffic_numericFormat__mjd7Z {
  border: none;
  cursor: pointer;
  color: #000;
  background-color: transparent;
  outline: none;
  caret-color: transparent;
  pointer-events: none;
  width: 100%;
}

.traffic_cursor_help__oZjQO {
  cursor: help;
}

.traffic_media_detail_name__5lPuf {
  font-size: 27px;
  font-weight: 800;
  text-align: center;
  /* white-space: nowrap; */
}

.traffic_text_info_area__b1Bfo {
  /* height: 150px; */
  /* border-bottom: 1px dashed #e0e0e0; */
  overflow: auto;
}

.traffic_text_info_area__b1Bfo table {
  margin-bottom: 0;
}

.traffic_text_info_area__b1Bfo table tr {
  border-style: dashed;
}

.traffic_text_info_area__b1Bfo table td {
  border: none;
}

.traffic_text_info_area__b1Bfo table p {
  margin-bottom: 0;
}

.traffic_type_img_wrapper__cQRut {
  width: 119px;
  min-width: 119px;
  aspect-ratio: 10/6;
  overflow: hidden;
  display: flex;
  justify-content: center;
}

.traffic_type_img_wrapper__cQRut img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.traffic_guide_tab__76Izb {
  height: 50vh;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.traffic_guide_tab__76Izb::-webkit-scrollbar {
  display: none;
}

.traffic_plan_modal__ppIg9 {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  min-width: 200px;
  padding: 0.5rem 1rem;
  background-color: #fff;
  border: 1px solid #961d4c;
  bottom: 90px;
  width: 115%;
  text-align: center;
}

.traffic_plan_title__ADv1r {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.traffic_guide_wrapper__wk2Vl {
  position: absolute;
  left: -11px;
  top: 55px;
  background-color: #fff;
  border: 1px solid #961d4c;
  padding: 12px;
  width: 400px;
  z-index: 9999;
}

.traffic_mt_4vh__JoIYc {
  margin-top: 4vh;
}

@media (max-width: 1680px) {
  .traffic_pt_33px__e-J-s {
    padding-top: 40px;
  }

  .traffic_buttonGroup__GCKN1 {
    width: 40px;
    height: 40px;
  }

  .traffic_pt_13px__Yh63E {
    padding-top: 2px;
  }

  .traffic_guide_wrapper__wk2Vl {
    top: 38px;
  }
}

@media (max-width: 1280px) {
  .traffic_top_bar__XkAeX {
    padding-left: 24px;
  }

  .traffic_toTop__RdBfn {
    padding-right: 24px;
  }

  .traffic_page_container__JEyof {
    padding-left: 24px;
    padding-right: 24px;
  }

  /* .media_detail_name {
    font-size: 20px;
  } */

  .traffic_detail_option_container__vxVcF {
    max-width: 389.5px;
    min-width: 389.5px;
    padding-top: 10px;
  }

  .traffic_custom_datepicker__msrTe {
    width: 100%;
  }

  .traffic_scroll_container__JnIQC {
    margin-right: 0;
    padding-bottom: 45px;
  }

  .traffic_content_container__t7s6D {
    padding-bottom: 110px;
  }

  .traffic_main_img_wrapper__I-IvW {
    height: 38.5vw;
  }

  .traffic_detail_container__Ef4Hd {
    padding-left: 0;
    width: calc(92vw);
  }

  .traffic_detail_width__PgRt6 {
    padding-right: 0;
    width: calc(100% - 9vw);
  }

  .traffic_detail_text_container__Ly-Nd {
    padding-left: 1rem;
    padding-bottom: 4rem;
  }

  .traffic_slick_dots__pyCIG li {
    width: 10vw !important;
    height: 5vw !important;
  }

  .traffic_detail_info__GbwWT,
  .traffic_detail_option_container__vxVcF {
    padding-bottom: 50px;
  }

  .traffic_cart_wrapper__ECudj {
    padding-bottom: 90px;
  }

  .traffic_scroll_h_container__rCBtT {
    height: calc((var(--vh, 1vh) * 100) - 165px);
  }

  /* .plan_modal {
    top: 41px;
    right: 0;
    left: auto;
    bottom: auto;
  } */

  .traffic_guide_tab__76Izb {
    height: 30vh;
  }

  .traffic_guide_wrapper__wk2Vl {
    left: 50%;
    transform: translate(-50%);
    width: 100%;
  }
}

@media (max-width: 1279px) {
  .traffic_buttonGroup__GCKN1 {
    height: 34px;
    width: 34px;
  }

  .traffic_plan_modal__ppIg9 {
    bottom: 85px;
  }
}

@media (max-width: 1199px) {
  .traffic_main_container__Xukm1 {
    height: auto;
  }

  .traffic_detail_container__Ef4Hd {
    flex-wrap: wrap;
    width: 100%;
    gap: 0;
  }

  .traffic_main_img_wrapper__I-IvW {
    height: 45.5vw;
  }

  .traffic_detail_option_container__vxVcF {
    /* height: auto; */
    padding-bottom: 40px;
  }

  .traffic_slick_dots__pyCIG li {
    width: 20vw !important;
    height: 10vw !important;
  }

  .traffic_detail_width__PgRt6 {
    width: 100%;
  }

  .traffic_content_box__VLQGq {
    position: static;
    padding-top: 10px;
  }

  .traffic_detail_scroll__RBaA5 {
    height: auto;
  }
}

@media (max-width: 768px) {
  .traffic_scroll_h_container__rCBtT {
    height: calc((var(--vh, 1vh) * 100) - 113px);
  }

  .traffic_option_price__Wvk9U {
    align-items: end;
  }

  .traffic_media_option__MQFcE {
    padding-bottom: 0;
  }

  .traffic_top_bar__XkAeX {
    padding-top: 17px;
  }

  .traffic_bd_bottom_dashed__vmNjL {
    padding: 3px 0;
  }

  .traffic_scroll_container__JnIQC.traffic_detail_scroll__RBaA5 {
    height: auto;
    padding-bottom: 0;
  }

  .traffic_main_container__Xukm1 {
    min-height: calc((var(--vh, 1vh) * 100) - 150px);
    margin: 0;
  }

  .traffic_scroll_container__JnIQC {
    height: calc((var(--vh, 1vh) * 100) - 150px);
  }

  .traffic_main_img_wrapper__I-IvW {
    height: 50.5vw;
  }

  .traffic_detail_text_container__Ly-Nd {
    padding-bottom: 1rem;
    min-width: initial;
  }

  .traffic_cart_wrapper__ECudj {
    right: -50%;
    bottom: -50px;
  }

  .traffic_slider_wrapper__tnAs- {
    padding: 0;
  }

  .traffic_custom_datepicker__msrTe {
    padding: 0;
    padding-right: 20px;
    height: 23px;
  }

  .traffic_custom_arrow__p3g5Y img {
    width: 13px;
  }

  .traffic_ppt_9px__hClMj {
    padding-top: 9.7px;
  }

  .traffic_tag_whole_group__pHswx,
  .traffic_detail_mobile_content__XvVf8 {
    padding-right: 18px;
  }

  .traffic_detail_option_container__vxVcF {
    padding-right: 16px;
    padding-left: 16px;
    padding-bottom: 11px;
  }

  .traffic_fs_27px__\\+Dj9I {
    font-size: 19.753px;
  }

  .traffic_fs_17px__rd05G {
    font-size: 13px;
  }

  .traffic_fs_18px__BUr7z {
    font-size: 14px;
  }

  .traffic_fs_14px__jQrDy {
    font-size: 8.885px;
  }

  .traffic_fs_13px__2Fb4g {
    font-size: 10px;
  }

  .traffic_tag_group__rNXn4 {
    padding-top: 0;
    padding-bottom: 6px;
  }

  .traffic_icon_wrapper__94qQD {
    width: 20px;
    height: 20px;
  }

  .traffic_top_bar__XkAeX {
    width: 98%;
    padding-left: 13px;
  }

  .traffic_fs_11px__yOJI8 {
    font-size: 8.787px;
  }

  .traffic_fs_27px__\\+Dj9I {
    font-size: 19.753px;
  }

  .traffic_swiper_thumbnail_wrapper__ckH\\+R {
    height: 96.364px;
  }

  .traffic_swiper_thumbnail_wrapper__ckH\\+R img {
    height: 37.515px;
    object-fit: cover;
  }

  .traffic_fs_11px__yOJI8 {
    font-size: 7.179px;
  }

  .traffic_fs_14px__jQrDy {
    font-size: 8.885px;
  }

  .traffic_slider_wrapper__tnAs- {
    padding: 0;
  }

  .traffic_swiper_thumbnail_wrapper__ckH\\+R {
    margin-top: 2.35px;
  }

  .traffic_slider_thumbnail__bKP8R {
    height: 37.515px !important;
  }

  .traffic_icon_size__sTDos {
    height: 25px;
    width: 25px;
    margin-right: 4.99px;
  }

  .traffic_content_title__6Yla\\+ {
    top: 34px;
    font-size: 11.358px;
    padding-top: 18px;
  }

  .traffic_content_sub_title__0IRWg {
    position: sticky;
    font-size: 11.358px;
    top: 63px;
    padding-top: 10px;
  }

  .traffic_content_inner_title__ExkAw {
    position: sticky;
    top: 94px;
    font-size: 10px;
    font-weight: 800;
    padding-top: 2px;
    padding-bottom: 10px;
    background-color: #fff;
  }

  .traffic_page_container__JEyof {
    padding-left: 13px;
    padding-right: 1px;
  }

  .traffic_item_sort__U62Vk > * {
    padding-right: 6.17px;
  }

  .traffic_media_name__2Lshk {
    font-size: 13px;
    line-height: 17.778px;
    padding-bottom: 1px;
  }

  .traffic_media_type__ce3AZ {
    font-size: 8px;
    line-height: 10.123px;
    padding-bottom: 3px;
  }

  .traffic_option_price__Wvk9U {
    font-size: 10px;
  }

  .traffic_detail_info__GbwWT {
    padding-top: 20px;
    padding-left: 0;
    padding-right: 0;
  }

  .traffic_toTop__RdBfn {
    padding-right: 13px;
  }

  .traffic_item_grid__D\\+-l2 {
    padding-bottom: 13px;
  }

  .traffic_pt_33px__e-J-s {
    padding-top: 18px;
  }

  .traffic_ppt_45px__bL67J {
    padding-top: 22.5px;
  }

  .traffic_fs_20px__iiR0R {
    font-size: 15px;
  }

  .traffic_fs_11px__yOJI8 {
    font-size: 8.787px;
  }

  .traffic_fs_14px__jQrDy {
    font-size: 8.885px;
  }

  .traffic_fs_17px__rd05G {
    font-size: 13px;
  }

  .traffic_option_select__ys6cq {
    font-size: 8.787px;
    height: 23px;
  }

  .traffic_datepicker_arrow__lcZNS img {
    width: 13px;
  }

  .traffic_w_97px__4i-LP {
    width: 77px;
    white-space: nowrap;
  }

  .traffic_px_30px__yDTaS {
    padding-left: 24px;
    padding-right: 24px;
  }

  .traffic_text_info_area__b1Bfo table > :not(caption) > * > * {
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
  }

  .traffic_plan_modal__ppIg9 {
    left: inherit;
    right: -62px;
    bottom: 38px;
    transform: inherit;
  }

  .traffic_guide_wrapper__wk2Vl {
    top: 30px;
    width: calc(100% - 20px);
  }

  .traffic_detail_info__GbwWT,
  .traffic_detail_option_container__vxVcF {
    padding-bottom: 0;
  }

  .traffic_option_media_price__4ds0e {
    font-size: 13px;
  }

  .traffic_media_option_type__3nfNN {
    font-size: 8px;
  }

  .traffic_mobile_plan_modal__jnDaS {
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    width: 80%;
  }

  .traffic_plan_title__ADv1r {
    font-size: 10px;
  }

  .traffic_tag_color__Tiq3O {
    padding-top: 2px;
    padding-bottom: 2px;
  }
}

@media (max-width: 360px) {
  .traffic_top_bar__XkAeX {
    width: 97%;
  }
}

/* @media (max-width: 360px) {
  .top_bar {
    width: 97%;
  }

  .fs_11px {
    font-size: 8.787px;
  }

  .fs_27px {
    font-size: 19.753px;
  }

  .swiper_thumbnail_wrapper {
    height: 54.364px;
  }

  .swiper_thumbnail_wrapper img {
    height: 37.515px;
    object-fit: cover;
  }

  .fs_11px {
    font-size: 7.179px;
  }

  .fs_14px {
    font-size: 8.885px;
  }

  .slider_wrapper {
    padding: 0;
  }

  .swiper_thumbnail_wrapper {
    margin-top: 2.35px;
  }

  .slider_thumbnail {
    height: 37.515px !important;
  }

  .icon_size {
    height: 20px;
    width: 20px;
    margin-right: 4.99px;
  }

  .content_title {
    top: 31px;
    font-size: 11.358px;
    padding-top: 18px;
  }

  .content_sub_title {
    position: sticky;
    font-size: 11.358px;
    top: 60px;
    padding-top: 10px;
  }

  .content_inner_title {
    position: sticky;
    top: 90px;
    font-size: 10px;
    font-weight: 800;
    padding-top: 2px;
    padding-bottom: 10px;
    background-color: #fff;
  }

  .page_container {
    padding-left: 13px;
  }

  .item_sort > * {
    padding-right: 6.17px;
  }

  .media_name {
    font-size: 13px;
    line-height: 17.778px;
    padding-bottom: 1px;
  }

  .media_type {
    font-size: 8px;
    line-height: 10.123px;
    padding-bottom: 3px;
  }

  .option_price {
    font-size: 10px;
  }

  .detail_option_container {
    padding-right: 33px;
  }

  .detail_info {
    padding-top: 20px;
  }

  .top_bar {
    padding-left: 16px;
  }

  .toTop {
    padding-right: 10px;
  }

  .item_grid {
    padding-bottom: 13px;
  }

  .pt_33px {
    padding-top: 18px;
  }

  .ppt_45px {
    padding-top: 22.5px;
  }

  .fs_20px {
    font-size: 15px;
  }

  .fs_11px {
    font-size: 8.787px;
  }

  .fs_14px {
    font-size: 8.885px;
  }

  .fs_17px {
    font-size: 13px;
  }

  .option_select {
    font-size: 8.787px;
    height: 23px;
  }

  .datepicker_arrow img {
    width: 15px;
  }

  .w_97px {
    width: 77px;
    white-space: nowrap;
  }

  .px_30px {
    padding-left: 24px;
    padding-right: 24px;
  }

  .detail_option_container {
    padding-bottom: 22.6px;
  }
} */

@media (max-height: 900px) {
  .traffic_customSelect__pqngE {
    max-height: 180px;
    overflow-y: auto;
  }

  .traffic_pt_33px__e-J-s {
    padding-top: 14px;
  }

  .traffic_mt_4vh__JoIYc {
    margin-top: 0.5vh;
  }

  .traffic_pt_10px__jpJDh {
    padding-top: 5px;
  }
}

@media (max-height: 700px) {
  .traffic_customSelect__pqngE {
    max-height: 130px;
    overflow-y: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/traffic.module.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB;EACE,iBAAiB;EACjB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;EAChB,kDAAkD;EAClD,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,MAAM;EACN,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,UAAU;EACV,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,wBAAwB;EACxB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,QAAQ;EACR,yBAAyB;EACzB,+CAA+C;EAC/C,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;;;GAKG;;AAEH;;GAEG;;AAEH;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;;GAEG;;AAEH;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2CAA2C;EAC3C,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;;;;;;;;;;;GAWG;AACH;EACE,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;EACX,6BAA6B;EAC7B,aAAa;EACb,wBAAwB;EACxB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;;KAEG;;EAEH;IACE,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;;IAEE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;;;;;KAKG;;EAEH;IACE,YAAY;EACd;;EAEA;IACE,SAAS;IACT,0BAA0B;IAC1B,WAAW;EACb;AACF;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,WAAW;IACX,MAAM;EACR;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,4CAA4C;EAC9C;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,gDAAgD;IAChD,SAAS;EACX;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,SAAS;IACT,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,wBAAwB;EAC1B;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAiKG;;AAEH;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;AACF","sourcesContent":["@charset \"utf-8\";\n\n.main_container {\n  max-width: 1920px;\n  width: 100%;\n  background-color: #fff;\n  margin: 10px auto 0;\n}\n\n.page_container {\n  padding-left: 24px;\n}\n\n.content_box {\n  padding-top: 72.65px;\n  background-color: #f2f2f2;\n  position: fixed;\n  max-width: 1920px;\n  width: 100%;\n}\n\n.scroll_container {\n  overflow-y: auto;\n  min-height: calc((var(--vh, 1vh) * 100) - 110px);\n}\n\n.scroll_h_container {\n  overflow-y: auto;\n  /* height: calc((var(--vh, 1vh) * 100) - 113px); */\n  height: calc((var(--vh, 1vh) * 100) - 113px);\n}\n\n.detail_scroll {\n  height: calc((var(--vh, 1vh) * 100) - 110px);\n  overflow-y: auto;\n}\n\n.scroll_container.detail_scroll {\n  height: calc((var(--vh, 1vh) * 100) - 110px);\n}\n\n.top_bar {\n  width: 99%;\n  position: absolute;\n  z-index: 99;\n  background-color: #fff;\n  padding-top: 13px;\n  top: 0;\n  padding-left: 24px;\n}\n\n.content_title {\n  position: sticky;\n  top: 48px;\n  font-size: 22.5px;\n  font-weight: 800;\n  background-color: #fff;\n  z-index: 11;\n  padding-top: 28px;\n}\n\n.content_sub_title {\n  position: sticky;\n  font-weight: 800;\n  font-size: 19px;\n  top: 97.5px;\n  background-color: #fff;\n  z-index: 1;\n  padding-top: 15px;\n  padding-bottom: 10px;\n}\n\n.content_inner_title {\n  position: sticky;\n  top: 140px;\n  font-weight: 700;\n  padding-top: 2px;\n  padding-bottom: 10px;\n  background-color: #fff;\n}\n\n.content_wrapper {\n  padding-top: 34px;\n  --bs-gutter-x: 0 !important;\n  margin-top: 0 !important;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n\n.item_sort {\n  --bs-gutter-x: 0 !important;\n}\n\n.item_sort > * {\n  padding-right: 23px;\n  padding-left: 0px !important;\n}\n\n.content_text {\n  white-space: pre-wrap;\n}\n\n.list_img {\n  width: 100%;\n  overflow: hidden;\n  aspect-ratio: 5 / 3;\n  background-color: rgb(164, 164, 164);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n}\n\n.list_img img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.toTop {\n  cursor: pointer;\n  margin-left: auto;\n  padding-right: 24px;\n}\n\n.icon_wrapper {\n  height: 28px;\n  width: 28px;\n}\n\n.icon_wrapper img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  cursor: pointer;\n}\n\n.item_wrapper {\n  background-color: #f2f2f2;\n  cursor: pointer;\n  transition: 0.4s;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.item_wrapper.active {\n  background-color: #fff2e9;\n}\n\n.item_wrapper .list_img img {\n  transition: all 0.5s ease-in-out;\n}\n\n.item_wrapper.active .list_img img {\n  width: 110%;\n  height: 110%;\n}\n\n.detail_width {\n  width: calc(100% - 153px);\n}\n\n.detail_container {\n  margin-left: 0 !important;\n  gap: 7px;\n  width: calc(100% - 183px);\n  min-height: calc((var(--vh, 1vh) * 100) - 98px);\n  flex-wrap: nowrap;\n}\n\n.detail_text_container {\n  background-color: #fff;\n  padding: 61px 17px 0 17px;\n  overflow: visible;\n  min-width: 422.5px;\n}\n\n.icon18px {\n  width: 18px;\n  height: 18px;\n}\n\n.main_img_wrapper {\n  width: 100%;\n  height: 27.5vw;\n  background-color: #f2f2f2;\n}\n\n.main_img_wrapper img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.media_wrapper {\n  padding: 10px 6.5px 9px 8.5px;\n  flex-grow: 1;\n}\n\n.media_name {\n  font-size: 17.5px;\n  font-weight: 800;\n  /* padding-bottom: 8px; */\n  line-height: 1;\n}\n\n.media_type {\n  padding-bottom: 13px;\n  font-size: 10px;\n  line-height: 1;\n}\n\n.media_option {\n  padding-bottom: 5px;\n  font-size: 10px;\n  display: flex;\n  gap: 7px;\n  line-height: 1;\n}\n\n.detail_mobile_content {\n  padding-left: 21px !important;\n  padding-right: 21px !important;\n}\n\n.option_price {\n  font-size: 15px;\n  font-weight: 800;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: auto;\n  line-height: 1;\n}\n\n.slick_dots {\n  position: static !important;\n  text-align: start !important;\n  /* width: auto !important; */\n  white-space: nowrap;\n  overflow-x: auto;\n}\n\n.slick_dots::-webkit-scrollbar {\n  display: none;\n  /* Chrome, Safari, Opera*/\n}\n\n.slick_dots li {\n  margin: 0 4px 0 0 !important;\n  width: 8vw !important;\n  height: 4vw !important;\n}\n\n.buttonGroup {\n  height: 40px;\n  width: 40px;\n}\n\n.buttonGroup img {\n  height: 100%;\n}\n\n.row {\n  --bs-gutter-x: 0.3rem;\n}\n\n.px_30px {\n  padding-left: 30px;\n  padding-right: 30px;\n}\n\n/* .cart_wrapper,\n.guide_wrapper {\n  width: 320px;\n  left: 50%;\n  transform: translateX(-50%);\n} */\n\n/* .guide_wrapper {\n  width: 500px;\n} */\n\n.cart_border {\n  border: 1px solid #971b4d;\n  background-color: #ffffffb4;\n  padding: 15px 11px 12px 12px;\n}\n\n.slider_wrapper {\n  width: 100%;\n  padding: 0 12px;\n}\n\n.swiper_thumbnail_wrapper {\n  margin-top: 5.5px;\n}\n\n.swiper_thumbnail_wrapper img {\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  object-fit: cover;\n}\n\n/* .swiper_thumbnail_wrapper .swiper_thumbnail {\n  opacity: 0.4;\n} */\n\n.slider_container {\n  aspect-ratio: 16 / 9;\n  overflow: hidden;\n}\n\n.slider_container iframe,\n.slider_container img {\n  min-height: 100%;\n  min-width: 100%;\n}\n\n.slider_active_div {\n  position: relative;\n  width: 100%;\n  padding-top: 56.25%;\n  background-color: #f0f0f0;\n  overflow: hidden;\n}\n\n.slider_media {\n  width: 100% !important;\n  height: 100% !important;\n}\n\n.slider_thumbnail {\n  /* width: 100% !important; */\n  aspect-ratio: 16 / 9 !important;\n}\n\n.slider_shadow {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  box-shadow: 0 0 0 3px #971b4d inset;\n}\n\n.bd_bottom_dashed {\n  /* border-bottom: 1px dashed #e0e0e0; */\n  padding: 13px 0;\n}\n\n.detail_info {\n  padding-top: 39px;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.detail_info img {\n  width: 100%;\n}\n\n.detail_option_container {\n  height: calc((var(--vh, 1vh) * 100) - 98px);\n  overflow: hidden;\n  min-width: 422.5px;\n  max-width: 422.5px;\n  background-color: #fff;\n  padding: 82.5px 23.5px 0 23.5px;\n}\n\n.option_select {\n  width: 100%;\n  background-color: #f2f2f2;\n  height: 29px;\n  font-size: 11px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* color: hsl(0, 0%, 50%); */\n  color: #000;\n  cursor: pointer;\n}\n\n.media_name_width {\n  width: 100%;\n  max-width: 325px;\n  padding: 0 16px;\n}\n\n.back_button {\n  cursor: pointer;\n  position: absolute;\n  left: 23.5px;\n}\n\n.linkText {\n  text-decoration: underline;\n}\n\n.custom_paging .slick-slide {\n  margin-right: 4px;\n}\n\n.custom_slider_a {\n  position: relative;\n  color: #000;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.custom_slider_a:focus-visible {\n  outline: none;\n}\n\n.slick-slider .slick-list {\n  width: 100%;\n}\n\n.icon_size {\n  width: 36px;\n  height: 36px;\n  margin-right: 7.5px;\n}\n\n.custom_datepicker {\n  background-color: #f2f2f2;\n  border: 0;\n  text-align: center;\n  padding: 0 2px;\n  padding-right: 30px;\n  width: 140px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 30px;\n}\n\n.option_ea {\n  width: 88px;\n  margin-left: 8.5px;\n}\n\n.custom_datepicker:focus {\n  border: 0;\n}\n\n/* .custom_datepicker::after {\n  content: '';\n  display: block;\n  width: 16px;\n  height: 16px;\n  background: url('../../public/image/icon/detail_select.svg') no-repeat;\n  background-size: contain;\n  position: absolute;\n  top: 50%;\n  right: 0;\n  transform: translateY(-50%);\n} */\n.datepicker_arrow {\n  top: 50%;\n  transform: translateY(-50%);\n  right: 5px;\n  cursor: pointer;\n  pointer-events: none;\n}\n\n.selectClose {\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n}\n\n.fs_9px {\n  font-size: 9px;\n}\n\n.fs_10px {\n  font-size: 10px;\n}\n\n.fs_11px {\n  font-size: 11px;\n}\n\n.fs_12px {\n  font-size: 12px;\n}\n\n.fs_13px {\n  font-size: 13px;\n}\n\n.fs_14px {\n  font-size: 14px;\n}\n\n.fs_17px {\n  font-size: 17px;\n}\n\n.fs_18px {\n  font-size: 18px;\n}\n\n.fs_20px {\n  font-size: 20px;\n}\n\n.fs_27px {\n  font-size: 27.5px;\n}\n\n.pfs_9px {\n  font-size: 9.5px;\n}\n\n.pt_8px {\n  padding-top: 8px;\n}\n\n.pt_10px {\n  padding-top: 10px;\n}\n\n.pt_13px {\n  padding-top: 13px;\n}\n\n.pt_33px {\n  padding-top: 33px;\n}\n\n.ppt_4px {\n  padding-top: 4.5px;\n}\n\n.ppt_45px {\n  padding-top: 45.5px;\n}\n\n.py_20px {\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n\n.ps_20px {\n  padding-left: 18px;\n}\n\n.w_97px {\n  width: 97px;\n}\n\n.customSelect {\n  width: 100%;\n  border: 1px solid #961d4c;\n  position: absolute;\n  background-color: rgb(255, 255, 255);\n  margin-top: 0.25rem;\n  z-index: 9999;\n}\n\n.customOption {\n  font-size: 11px;\n  text-align: center;\n  cursor: pointer;\n  line-height: 34px;\n  font-weight: 700;\n  padding-top: 0.1rem;\n  padding-bottom: 0.1rem;\n}\n\n.customOption:hover {\n  background-color: #f2f2f2;\n}\n\n.tag_whole_group {\n  display: flex;\n  align-items: center;\n  gap: 7.5px;\n  padding-right: 21px;\n}\n\n.tag_group {\n  flex-grow: 1;\n  width: 100%;\n  margin: 0 !important;\n  align-items: center;\n  justify-content: space-around;\n  flex-wrap: nowrap;\n  gap: 5.5px;\n}\n\n.tag_group.bd_bottom_dashed {\n  padding-bottom: 7.5px;\n}\n\n.tag_color {\n  padding-top: 8px;\n  padding-bottom: 7px;\n  text-align: center;\n  border-radius: 5px;\n  font-size: 10px;\n}\n\n.tag_div > div {\n  flex: 1;\n}\n\n.item_grid {\n  padding-bottom: 24px;\n}\n\n.numericFormat {\n  border: none;\n  cursor: pointer;\n  color: #000;\n  background-color: transparent;\n  outline: none;\n  caret-color: transparent;\n  pointer-events: none;\n  width: 100%;\n}\n\n.cursor_help {\n  cursor: help;\n}\n\n.media_detail_name {\n  font-size: 27px;\n  font-weight: 800;\n  text-align: center;\n  /* white-space: nowrap; */\n}\n\n.text_info_area {\n  /* height: 150px; */\n  /* border-bottom: 1px dashed #e0e0e0; */\n  overflow: auto;\n}\n\n.text_info_area table {\n  margin-bottom: 0;\n}\n\n.text_info_area table tr {\n  border-style: dashed;\n}\n\n.text_info_area table td {\n  border: none;\n}\n\n.text_info_area table p {\n  margin-bottom: 0;\n}\n\n.type_img_wrapper {\n  width: 119px;\n  min-width: 119px;\n  aspect-ratio: 10/6;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n}\n\n.type_img_wrapper img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.guide_tab {\n  height: 50vh;\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.guide_tab::-webkit-scrollbar {\n  display: none;\n}\n\n.plan_modal {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  min-width: 200px;\n  padding: 0.5rem 1rem;\n  background-color: #fff;\n  border: 1px solid #961d4c;\n  bottom: 90px;\n  width: 115%;\n  text-align: center;\n}\n\n.plan_title {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.guide_wrapper {\n  position: absolute;\n  left: -11px;\n  top: 55px;\n  background-color: #fff;\n  border: 1px solid #961d4c;\n  padding: 12px;\n  width: 400px;\n  z-index: 9999;\n}\n\n.mt_4vh {\n  margin-top: 4vh;\n}\n\n@media (max-width: 1680px) {\n  .pt_33px {\n    padding-top: 40px;\n  }\n\n  .buttonGroup {\n    width: 40px;\n    height: 40px;\n  }\n\n  .pt_13px {\n    padding-top: 2px;\n  }\n\n  .guide_wrapper {\n    top: 38px;\n  }\n}\n\n@media (max-width: 1280px) {\n  .top_bar {\n    padding-left: 24px;\n  }\n\n  .toTop {\n    padding-right: 24px;\n  }\n\n  .page_container {\n    padding-left: 24px;\n    padding-right: 24px;\n  }\n\n  /* .media_detail_name {\n    font-size: 20px;\n  } */\n\n  .detail_option_container {\n    max-width: 389.5px;\n    min-width: 389.5px;\n    padding-top: 10px;\n  }\n\n  .custom_datepicker {\n    width: 100%;\n  }\n\n  .scroll_container {\n    margin-right: 0;\n    padding-bottom: 45px;\n  }\n\n  .content_container {\n    padding-bottom: 110px;\n  }\n\n  .main_img_wrapper {\n    height: 38.5vw;\n  }\n\n  .detail_container {\n    padding-left: 0;\n    width: calc(92vw);\n  }\n\n  .detail_width {\n    padding-right: 0;\n    width: calc(100% - 9vw);\n  }\n\n  .detail_text_container {\n    padding-left: 1rem;\n    padding-bottom: 4rem;\n  }\n\n  .slick_dots li {\n    width: 10vw !important;\n    height: 5vw !important;\n  }\n\n  .detail_info,\n  .detail_option_container {\n    padding-bottom: 50px;\n  }\n\n  .cart_wrapper {\n    padding-bottom: 90px;\n  }\n\n  .scroll_h_container {\n    height: calc((var(--vh, 1vh) * 100) - 165px);\n  }\n\n  /* .plan_modal {\n    top: 41px;\n    right: 0;\n    left: auto;\n    bottom: auto;\n  } */\n\n  .guide_tab {\n    height: 30vh;\n  }\n\n  .guide_wrapper {\n    left: 50%;\n    transform: translate(-50%);\n    width: 100%;\n  }\n}\n\n@media (max-width: 1279px) {\n  .buttonGroup {\n    height: 34px;\n    width: 34px;\n  }\n\n  .plan_modal {\n    bottom: 85px;\n  }\n}\n\n@media (max-width: 1199px) {\n  .main_container {\n    height: auto;\n  }\n\n  .detail_container {\n    flex-wrap: wrap;\n    width: 100%;\n    gap: 0;\n  }\n\n  .main_img_wrapper {\n    height: 45.5vw;\n  }\n\n  .detail_option_container {\n    /* height: auto; */\n    padding-bottom: 40px;\n  }\n\n  .slick_dots li {\n    width: 20vw !important;\n    height: 10vw !important;\n  }\n\n  .detail_width {\n    width: 100%;\n  }\n\n  .content_box {\n    position: static;\n    padding-top: 10px;\n  }\n\n  .detail_scroll {\n    height: auto;\n  }\n}\n\n@media (max-width: 768px) {\n  .scroll_h_container {\n    height: calc((var(--vh, 1vh) * 100) - 113px);\n  }\n\n  .option_price {\n    align-items: end;\n  }\n\n  .media_option {\n    padding-bottom: 0;\n  }\n\n  .top_bar {\n    padding-top: 17px;\n  }\n\n  .bd_bottom_dashed {\n    padding: 3px 0;\n  }\n\n  .scroll_container.detail_scroll {\n    height: auto;\n    padding-bottom: 0;\n  }\n\n  .main_container {\n    min-height: calc((var(--vh, 1vh) * 100) - 150px);\n    margin: 0;\n  }\n\n  .scroll_container {\n    height: calc((var(--vh, 1vh) * 100) - 150px);\n  }\n\n  .main_img_wrapper {\n    height: 50.5vw;\n  }\n\n  .detail_text_container {\n    padding-bottom: 1rem;\n    min-width: initial;\n  }\n\n  .cart_wrapper {\n    right: -50%;\n    bottom: -50px;\n  }\n\n  .slider_wrapper {\n    padding: 0;\n  }\n\n  .custom_datepicker {\n    padding: 0;\n    padding-right: 20px;\n    height: 23px;\n  }\n\n  .custom_arrow img {\n    width: 13px;\n  }\n\n  .ppt_9px {\n    padding-top: 9.7px;\n  }\n\n  .tag_whole_group,\n  .detail_mobile_content {\n    padding-right: 18px;\n  }\n\n  .detail_option_container {\n    padding-right: 16px;\n    padding-left: 16px;\n    padding-bottom: 11px;\n  }\n\n  .fs_27px {\n    font-size: 19.753px;\n  }\n\n  .fs_17px {\n    font-size: 13px;\n  }\n\n  .fs_18px {\n    font-size: 14px;\n  }\n\n  .fs_14px {\n    font-size: 8.885px;\n  }\n\n  .fs_13px {\n    font-size: 10px;\n  }\n\n  .tag_group {\n    padding-top: 0;\n    padding-bottom: 6px;\n  }\n\n  .icon_wrapper {\n    width: 20px;\n    height: 20px;\n  }\n\n  .top_bar {\n    width: 98%;\n    padding-left: 13px;\n  }\n\n  .fs_11px {\n    font-size: 8.787px;\n  }\n\n  .fs_27px {\n    font-size: 19.753px;\n  }\n\n  .swiper_thumbnail_wrapper {\n    height: 96.364px;\n  }\n\n  .swiper_thumbnail_wrapper img {\n    height: 37.515px;\n    object-fit: cover;\n  }\n\n  .fs_11px {\n    font-size: 7.179px;\n  }\n\n  .fs_14px {\n    font-size: 8.885px;\n  }\n\n  .slider_wrapper {\n    padding: 0;\n  }\n\n  .swiper_thumbnail_wrapper {\n    margin-top: 2.35px;\n  }\n\n  .slider_thumbnail {\n    height: 37.515px !important;\n  }\n\n  .icon_size {\n    height: 25px;\n    width: 25px;\n    margin-right: 4.99px;\n  }\n\n  .content_title {\n    top: 34px;\n    font-size: 11.358px;\n    padding-top: 18px;\n  }\n\n  .content_sub_title {\n    position: sticky;\n    font-size: 11.358px;\n    top: 63px;\n    padding-top: 10px;\n  }\n\n  .content_inner_title {\n    position: sticky;\n    top: 94px;\n    font-size: 10px;\n    font-weight: 800;\n    padding-top: 2px;\n    padding-bottom: 10px;\n    background-color: #fff;\n  }\n\n  .page_container {\n    padding-left: 13px;\n    padding-right: 1px;\n  }\n\n  .item_sort > * {\n    padding-right: 6.17px;\n  }\n\n  .media_name {\n    font-size: 13px;\n    line-height: 17.778px;\n    padding-bottom: 1px;\n  }\n\n  .media_type {\n    font-size: 8px;\n    line-height: 10.123px;\n    padding-bottom: 3px;\n  }\n\n  .option_price {\n    font-size: 10px;\n  }\n\n  .detail_info {\n    padding-top: 20px;\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  .toTop {\n    padding-right: 13px;\n  }\n\n  .item_grid {\n    padding-bottom: 13px;\n  }\n\n  .pt_33px {\n    padding-top: 18px;\n  }\n\n  .ppt_45px {\n    padding-top: 22.5px;\n  }\n\n  .fs_20px {\n    font-size: 15px;\n  }\n\n  .fs_11px {\n    font-size: 8.787px;\n  }\n\n  .fs_14px {\n    font-size: 8.885px;\n  }\n\n  .fs_17px {\n    font-size: 13px;\n  }\n\n  .option_select {\n    font-size: 8.787px;\n    height: 23px;\n  }\n\n  .datepicker_arrow img {\n    width: 13px;\n  }\n\n  .w_97px {\n    width: 77px;\n    white-space: nowrap;\n  }\n\n  .px_30px {\n    padding-left: 24px;\n    padding-right: 24px;\n  }\n\n  .text_info_area table > :not(caption) > * > * {\n    padding-top: 0.2rem;\n    padding-bottom: 0.2rem;\n  }\n\n  .plan_modal {\n    left: inherit;\n    right: -62px;\n    bottom: 38px;\n    transform: inherit;\n  }\n\n  .guide_wrapper {\n    top: 30px;\n    width: calc(100% - 20px);\n  }\n\n  .detail_info,\n  .detail_option_container {\n    padding-bottom: 0;\n  }\n\n  .option_media_price {\n    font-size: 13px;\n  }\n\n  .media_option_type {\n    font-size: 8px;\n  }\n\n  .mobile_plan_modal {\n    bottom: 10px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 80%;\n  }\n\n  .plan_title {\n    font-size: 10px;\n  }\n\n  .tag_color {\n    padding-top: 2px;\n    padding-bottom: 2px;\n  }\n}\n\n@media (max-width: 360px) {\n  .top_bar {\n    width: 97%;\n  }\n}\n\n/* @media (max-width: 360px) {\n  .top_bar {\n    width: 97%;\n  }\n\n  .fs_11px {\n    font-size: 8.787px;\n  }\n\n  .fs_27px {\n    font-size: 19.753px;\n  }\n\n  .swiper_thumbnail_wrapper {\n    height: 54.364px;\n  }\n\n  .swiper_thumbnail_wrapper img {\n    height: 37.515px;\n    object-fit: cover;\n  }\n\n  .fs_11px {\n    font-size: 7.179px;\n  }\n\n  .fs_14px {\n    font-size: 8.885px;\n  }\n\n  .slider_wrapper {\n    padding: 0;\n  }\n\n  .swiper_thumbnail_wrapper {\n    margin-top: 2.35px;\n  }\n\n  .slider_thumbnail {\n    height: 37.515px !important;\n  }\n\n  .icon_size {\n    height: 20px;\n    width: 20px;\n    margin-right: 4.99px;\n  }\n\n  .content_title {\n    top: 31px;\n    font-size: 11.358px;\n    padding-top: 18px;\n  }\n\n  .content_sub_title {\n    position: sticky;\n    font-size: 11.358px;\n    top: 60px;\n    padding-top: 10px;\n  }\n\n  .content_inner_title {\n    position: sticky;\n    top: 90px;\n    font-size: 10px;\n    font-weight: 800;\n    padding-top: 2px;\n    padding-bottom: 10px;\n    background-color: #fff;\n  }\n\n  .page_container {\n    padding-left: 13px;\n  }\n\n  .item_sort > * {\n    padding-right: 6.17px;\n  }\n\n  .media_name {\n    font-size: 13px;\n    line-height: 17.778px;\n    padding-bottom: 1px;\n  }\n\n  .media_type {\n    font-size: 8px;\n    line-height: 10.123px;\n    padding-bottom: 3px;\n  }\n\n  .option_price {\n    font-size: 10px;\n  }\n\n  .detail_option_container {\n    padding-right: 33px;\n  }\n\n  .detail_info {\n    padding-top: 20px;\n  }\n\n  .top_bar {\n    padding-left: 16px;\n  }\n\n  .toTop {\n    padding-right: 10px;\n  }\n\n  .item_grid {\n    padding-bottom: 13px;\n  }\n\n  .pt_33px {\n    padding-top: 18px;\n  }\n\n  .ppt_45px {\n    padding-top: 22.5px;\n  }\n\n  .fs_20px {\n    font-size: 15px;\n  }\n\n  .fs_11px {\n    font-size: 8.787px;\n  }\n\n  .fs_14px {\n    font-size: 8.885px;\n  }\n\n  .fs_17px {\n    font-size: 13px;\n  }\n\n  .option_select {\n    font-size: 8.787px;\n    height: 23px;\n  }\n\n  .datepicker_arrow img {\n    width: 15px;\n  }\n\n  .w_97px {\n    width: 77px;\n    white-space: nowrap;\n  }\n\n  .px_30px {\n    padding-left: 24px;\n    padding-right: 24px;\n  }\n\n  .detail_option_container {\n    padding-bottom: 22.6px;\n  }\n} */\n\n@media (max-height: 900px) {\n  .customSelect {\n    max-height: 180px;\n    overflow-y: auto;\n  }\n\n  .pt_33px {\n    padding-top: 14px;\n  }\n\n  .mt_4vh {\n    margin-top: 0.5vh;\n  }\n\n  .pt_10px {\n    padding-top: 5px;\n  }\n}\n\n@media (max-height: 700px) {\n  .customSelect {\n    max-height: 130px;\n    overflow-y: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main_container": `traffic_main_container__Xukm1`,
	"page_container": `traffic_page_container__JEyof`,
	"content_box": `traffic_content_box__VLQGq`,
	"scroll_container": `traffic_scroll_container__JnIQC`,
	"scroll_h_container": `traffic_scroll_h_container__rCBtT`,
	"detail_scroll": `traffic_detail_scroll__RBaA5`,
	"top_bar": `traffic_top_bar__XkAeX`,
	"content_title": `traffic_content_title__6Yla+`,
	"content_sub_title": `traffic_content_sub_title__0IRWg`,
	"content_inner_title": `traffic_content_inner_title__ExkAw`,
	"content_wrapper": `traffic_content_wrapper__vc1u7`,
	"item_sort": `traffic_item_sort__U62Vk`,
	"content_text": `traffic_content_text__7M-Tz`,
	"list_img": `traffic_list_img__+GO4n`,
	"toTop": `traffic_toTop__RdBfn`,
	"icon_wrapper": `traffic_icon_wrapper__94qQD`,
	"item_wrapper": `traffic_item_wrapper__kvCcX`,
	"active": `traffic_active__NMLlu`,
	"detail_width": `traffic_detail_width__PgRt6`,
	"detail_container": `traffic_detail_container__Ef4Hd`,
	"detail_text_container": `traffic_detail_text_container__Ly-Nd`,
	"icon18px": `traffic_icon18px__1FKjy`,
	"main_img_wrapper": `traffic_main_img_wrapper__I-IvW`,
	"media_wrapper": `traffic_media_wrapper__+T9ZR`,
	"media_name": `traffic_media_name__2Lshk`,
	"media_type": `traffic_media_type__ce3AZ`,
	"media_option": `traffic_media_option__MQFcE`,
	"detail_mobile_content": `traffic_detail_mobile_content__XvVf8`,
	"option_price": `traffic_option_price__Wvk9U`,
	"slick_dots": `traffic_slick_dots__pyCIG`,
	"buttonGroup": `traffic_buttonGroup__GCKN1`,
	"row": `traffic_row__wmPY-`,
	"px_30px": `traffic_px_30px__yDTaS`,
	"cart_border": `traffic_cart_border__xGnti`,
	"slider_wrapper": `traffic_slider_wrapper__tnAs-`,
	"swiper_thumbnail_wrapper": `traffic_swiper_thumbnail_wrapper__ckH+R`,
	"slider_container": `traffic_slider_container__WgUes`,
	"slider_active_div": `traffic_slider_active_div__4HCz9`,
	"slider_media": `traffic_slider_media__VxWyb`,
	"slider_thumbnail": `traffic_slider_thumbnail__bKP8R`,
	"slider_shadow": `traffic_slider_shadow__txwsZ`,
	"bd_bottom_dashed": `traffic_bd_bottom_dashed__vmNjL`,
	"detail_info": `traffic_detail_info__GbwWT`,
	"detail_option_container": `traffic_detail_option_container__vxVcF`,
	"option_select": `traffic_option_select__ys6cq`,
	"media_name_width": `traffic_media_name_width__7+0pU`,
	"back_button": `traffic_back_button__eC-cN`,
	"linkText": `traffic_linkText__Y5qZG`,
	"custom_paging": `traffic_custom_paging__6XMxu`,
	"slick-slide": `traffic_slick-slide__2Dojp`,
	"custom_slider_a": `traffic_custom_slider_a__-QMLq`,
	"slick-slider": `traffic_slick-slider__rX648`,
	"slick-list": `traffic_slick-list__yKqoF`,
	"icon_size": `traffic_icon_size__sTDos`,
	"custom_datepicker": `traffic_custom_datepicker__msrTe`,
	"option_ea": `traffic_option_ea__5BYDi`,
	"datepicker_arrow": `traffic_datepicker_arrow__lcZNS`,
	"selectClose": `traffic_selectClose__wZKnR`,
	"fs_9px": `traffic_fs_9px__EmysD`,
	"fs_10px": `traffic_fs_10px__Ndm2y`,
	"fs_11px": `traffic_fs_11px__yOJI8`,
	"fs_12px": `traffic_fs_12px__gVawU`,
	"fs_13px": `traffic_fs_13px__2Fb4g`,
	"fs_14px": `traffic_fs_14px__jQrDy`,
	"fs_17px": `traffic_fs_17px__rd05G`,
	"fs_18px": `traffic_fs_18px__BUr7z`,
	"fs_20px": `traffic_fs_20px__iiR0R`,
	"fs_27px": `traffic_fs_27px__+Dj9I`,
	"pfs_9px": `traffic_pfs_9px__0ZP9+`,
	"pt_8px": `traffic_pt_8px__YIICa`,
	"pt_10px": `traffic_pt_10px__jpJDh`,
	"pt_13px": `traffic_pt_13px__Yh63E`,
	"pt_33px": `traffic_pt_33px__e-J-s`,
	"ppt_4px": `traffic_ppt_4px__1bDpT`,
	"ppt_45px": `traffic_ppt_45px__bL67J`,
	"py_20px": `traffic_py_20px__eoidu`,
	"ps_20px": `traffic_ps_20px__QnP7r`,
	"w_97px": `traffic_w_97px__4i-LP`,
	"customSelect": `traffic_customSelect__pqngE`,
	"customOption": `traffic_customOption__KLObe`,
	"tag_whole_group": `traffic_tag_whole_group__pHswx`,
	"tag_group": `traffic_tag_group__rNXn4`,
	"tag_color": `traffic_tag_color__Tiq3O`,
	"tag_div": `traffic_tag_div__iCWz6`,
	"item_grid": `traffic_item_grid__D+-l2`,
	"numericFormat": `traffic_numericFormat__mjd7Z`,
	"cursor_help": `traffic_cursor_help__oZjQO`,
	"media_detail_name": `traffic_media_detail_name__5lPuf`,
	"text_info_area": `traffic_text_info_area__b1Bfo`,
	"type_img_wrapper": `traffic_type_img_wrapper__cQRut`,
	"guide_tab": `traffic_guide_tab__76Izb`,
	"plan_modal": `traffic_plan_modal__ppIg9`,
	"plan_title": `traffic_plan_title__ADv1r`,
	"guide_wrapper": `traffic_guide_wrapper__wk2Vl`,
	"mt_4vh": `traffic_mt_4vh__JoIYc`,
	"content_container": `traffic_content_container__t7s6D`,
	"cart_wrapper": `traffic_cart_wrapper__ECudj`,
	"custom_arrow": `traffic_custom_arrow__p3g5Y`,
	"ppt_9px": `traffic_ppt_9px__hClMj`,
	"option_media_price": `traffic_option_media_price__4ds0e`,
	"media_option_type": `traffic_media_option_type__3nfNN`,
	"mobile_plan_modal": `traffic_mobile_plan_modal__jnDaS`
};
export default ___CSS_LOADER_EXPORT___;
